export const hero_6_data = [
  {
    id: "Berthe's Brush",
    img: "/images/game/Berthe_Brush_at_Bougival.png",
    title: "Berthe's Brush at Bougival ",
     url: "https://youtube.com/embed/-nKpw68udfI",
  
    authorName: "A journey into art, nature, self-expression and well-being.",
  },
  {
    id: "Dog Park",
    img: "/images/game/Dog_Park.png",
    title: "Harold’s Park",
    url: "https://youtube.com/embed/Fs1ZfY85MAA",
    authorName: "A fun way to teach dog training tips, support and save the lives of rescue dogs.",
  },
  {
    id: "Eco Domes",
    img: "/images/game/Eco_Domes_and_Quad_B.png",
    title: "Eco-Domes & Quad B",
    url: "https://youtube.com/embed/8kswe-uEvRM",
    authorName: "Exploring customizable spaces and stadiums made from tyres!",
  },
  {
    id: "Library and Expert AI Mentors",
    img: "/images/game/Library_and_Expert_AI_Mentors.png",
    title: "Library & AI Experts",
    url: "https://youtube.com/embed/cY1JuK6TrR8", // https://youtube.com/shorts/nroivzDh-uM
    authorName: "A virtual safe space to learn with domain specific AI experts.",
  },
  {
    id: "Aunua",
    img: "/images/game/Aunua.png",
    url: "https://youtube.com/embed/UlbzCWKgwEo",
    title: "AUNUA Global",
    authorName: "Safe spaces for youth to learn, collaborate and lead with purpose.",
  },
  {
    id: "Sophia's AI",
    img: "/images/game/Sophia_AI_Lab.png",
    title: "Hanson Robotics",
    url: "https://youtube.com/embed/IdKWf-8M03Y",
    authorName: "By learning through play, coding and interacting, players help save the future. ",
  },
  {
    id: "Think Ocean Under Water Academy",
    img: "/images/game/fundamentals_of_business.png",
    title: "Fundamentals of Business",
    url: " https://youtube.com/embed/sCnPQjcO06Q",
    authorName: "A journey into Financial Literacy and Entrepreneurship",
  },
  {
    id: "Toonda",
    img: "/images/game/Toonda.png",
    title: "Toonda",
    url: "https://youtube.com/embed/p7q2pcJWsBI",
    authorName: "Where art, culture and education bring hope and opportunity!",
  },
  {
    id: "Turtle Guardians",
    img: "/images/game/Turtle_Guardians.png",
    title: "Turtle Guardians",
    url: "https://youtube.com/embed/t2O2tcZBQmg",
    authorName: "A learning-based mission to protect sea turtles, their habitat and ecosystem.",
  },
];
